/**
 * Memoria de filtros que sobrevive a la navegación, no a la recarga.
 *
 * El caso de uso, dicho por quien lo pidió: "si filtro para un mes y entro a
 * una llamada, y luego doy volver a llamadas, conserve los filtros". Hoy
 * `AnalyticsFilterBar` se desmonta al navegar y vuelve a nacer con la semana en
 * curso, así que el usuario pierde el rango cada vez que abre una llamada.
 *
 * Es memoria de MÓDULO a propósito, no `sessionStorage` ni `localStorage`:
 *
 *   · Sobrevive al desmontaje del componente y a los cambios de ruta, que es
 *     todo lo que se necesita para el ida y vuelta.
 *   · Muere al recargar la página, que es exactamente lo que se pidió — un
 *     refresh vuelve al default de la semana en curso. Con `sessionStorage` los
 *     filtros sobrevivirían al refresh y no habría forma de volver al default
 *     sin cerrar la pestaña.
 *
 * La clave es por pantalla (`window.location.pathname` por default), así que
 * filtrar en Llamadas no arrastra los filtros a Cumplimiento. Dos pantallas que
 * quieran compartirlos pueden pasar la misma clave explícita.
 */

const memoria = new Map();

/** Lo guardado para esa pantalla, o `null` si nunca se guardó nada. */
export function leerFiltros(clave) {
  return memoria.has(clave) ? memoria.get(clave) : null;
}

export function guardarFiltros(clave, valores) {
  memoria.set(clave, valores);
}

/**
 * Valor inicial de un filtro: lo guardado si existe, si no el default.
 *
 * Distingue "guardado como vacío" de "nunca guardado": un usuario que limpió el
 * rango de fechas a propósito no debe recibir la semana en curso otra vez al
 * volver de la llamada. Por eso se comprueba la presencia de la clave y no si
 * el valor es falsy.
 */
export function inicial(clave, campo, porDefecto) {
  const guardado = leerFiltros(clave);
  if (guardado && Object.prototype.hasOwnProperty.call(guardado, campo)) {
    return guardado[campo];
  }
  return porDefecto;
}
